import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUnlock } from "@fortawesome/free-solid-svg-icons";
import { T } from "react-translator-component";
import { NavLink, useLocation } from 'react-router-dom';
import { HotelContext } from "../context/hotel";

const AccessInformationNavLinkDashboard = ({containerStyle}) => {
    const { getUrlPath } = useContext(HotelContext);
    const { pathname } = useLocation();
    console.log('containerStyle',containerStyle)
    return (
        <>
            <NavLink to={getUrlPath("smartlock-general")} style={{ textDecoration: "none" }} className="access-information-link" state={{ from: pathname }}>
                <div className="px-3 py-2" style={containerStyle}>

                    <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                        <div className="nav-icon" style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <FontAwesomeIcon icon={faUnlock} color="#FFF" style={{ fontSize: 14 }} />
                        </div>
                        <div className="text-left">
                            <p className="mb-0" style={{ lineHeight: 1.25 }}>
                                <b style={{ color: "#555555" }}>{T("status.access_information")}</b>
                            </p>
                            <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                                {T("status.access_information_description")}
                            </p>
                        </div>
                    </div>
                </div>
            </NavLink>

        </>)
}


export default AccessInformationNavLinkDashboard;
